import * as React from "react";

const SvgInProgress = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 25 24"
  >
    <mask
      id="in_progress_svg__a"
      width={25}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="currentColor" d="M.412 0h24v24h-24z" />
    </mask>
    <g mask="url(#in_progress_svg__a)">
      <path
        fill="currentColor"
        d="m10.909 16-3.497-3.318.874-.83 2.623 2.489L16.538 9l.874.83zM3.262 16.075a9.4 9.4 0 0 1-.525-1.5A10 10 0 0 1 2.462 13h2.025q.075.525.212 1.05t.338 1.025zM2.462 11q.074-.8.275-1.587.2-.788.55-1.513l1.75 1a9 9 0 0 0-.338 1.025q-.137.525-.212 1.075zm4.125 9.15q-.675-.5-1.25-1.087A12 12 0 0 1 4.262 17.8l1.75-1q.35.45.737.837.388.388.838.738zm-.55-12.975-1.775-1q.5-.675 1.075-1.25t1.25-1.075l1 1.775a11.4 11.4 0 0 0-1.55 1.55m5.375 14.775a10.4 10.4 0 0 1-1.588-.275 8 8 0 0 1-1.512-.55l1-1.75q.5.2 1.025.337.525.138 1.075.213zm-2.1-17.325-1-1.75a8 8 0 0 1 1.512-.55 10.4 10.4 0 0 1 1.588-.275v2.025q-.55.074-1.075.213-.525.137-1.025.337"
      />
      <mask id="in_progress_svg__b" fill="currentColor">
        <path d="M13.4 2.049a10 10 0 0 1-.361 19.931l-.125-1.994a8.003 8.003 0 0 0 .288-15.949z" />
      </mask>
      <path
        stroke="currentColor"
        strokeWidth={4}
        d="M13.4 2.049a10 10 0 0 1-.361 19.931l-.125-1.994a8.003 8.003 0 0 0 .288-15.949z"
        mask="url(#in_progress_svg__b)"
      />
    </g>
  </svg>
);
export default SvgInProgress;
